import { RiCarouselView } from "react-icons/ri";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Offers Selection Slider",
  name: "offersSelectionSlider",
  type: "object",
  icon: RiCarouselView,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "heading",
      title: "Heading",
      type: "sectionTitle"
    },
    {
      name: "offers",
      title: "Offers",
      type: "array",
      of: [
        {
          type: "reference",
          to: [{ type: "exclusiveOfferPerPromo" }]
        }
      ]
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      offers: "offers"
    },
    prepare(selection) {
      const { title, offers } = selection;
      return {
        title:
          multilingualStringPreview(title) || "([Offers Selection] Slider)",
        subtitle: `${offers?.length} offers`
      };
    }
  }
});
